import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { carecentreTypeScale as type } from "../../typeScale";

const useStyles = makeStyles(() => ({
  label: {
    margin: 0,
    color: "#15191F",
    "& .MuiFormControlLabel-label": {
      fontSize: type.body.fontSize,
      lineHeight: `${type.body.lineHeight}px`,
    },
  },
  checkbox: {
    color: "#CAC7BE",
    "&.Mui-checked": {
      color: "#0765FF",
    },
  },
}));

/**
 * MUI Checkbox with label.
 */
const CcCheckbox = ({ label, className, ...props }) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      className={[classes.label, className].filter(Boolean).join(" ")}
      control={<Checkbox className={classes.checkbox} {...props} />}
      label={label}
    />
  );
};

export default CcCheckbox;
